import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import { Notifications } from 'types';
import { setJackpotWon, setStageJackpot } from 'data/reducers/AuthReducer';
import { onJackpotWonData } from './types';

// eslint-disable-next-line require-yield
export function* onJackpotFinishedSaga({ type: notificationType }: onJackpotWonData) {
  try {
    if (notificationType === Notifications.JACKPOT_FINISHED) {
      yield put(setJackpotWon(true));
      yield put(setStageJackpot(false));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
